export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9504.a27d27f6.jpg";